<script>
import Multiselect from 'vue-multiselect'
import UploadFile from '@components/upload-file'

export default {
  components: {Multiselect, UploadFile},
  props: ['uuid', 'action'],
  data() {
    return{
      title: null,
      name: null,
      description: null,
      google_table_url: null,      
      fl_ai: false,
      other: {},
      
      trackBy: 'id',
      audio_record: false,
      audio_record_variable: null,

      background_sound: false,
      attachments: new Map(),
      user_phone: null,
      options: {
        handle: '.handle',
        filter: '.disabled'
      },

      saveModal: false,
      loadModal: false,
      callModal: false,

      attaching_type: 'bots',
      attaching_uuid: null,

      call: {
        first_name: '',
        middle_name: '',
        last_name: '',
        variables: '',
        phone: '',
      },

      skill_name: null,
      skill_description: null,
      success_save_modal_text: null,
      success_save_modal: false,

    }
  },

  computed: {
    attachments_files: {
      get: function () {
        return this.attachments
      },
      set: function (value) {
        this.attachments = value;
      }
    },
    skill_item(){
      return this.$store.getters['skills/GET_SKILLS_ITEM'];
    },
  },

  watch: {
  },

  async created() {
    
    if (this.action === 'edite') {
      this.title = 'Редактирование бота';
      this.attaching_uuid = this.uuid;

      await this.$store.dispatch('bots/FETCH_BOTS_ITEM', {uuid: this.uuid});
      const {name, google_table_url, description, config, fl_ai, ...other} = this.$store.getters['bots/GET_BOTS_ITEM'];
      
      this.name = name
      this.description = description
      this.google_table_url = google_table_url
      this.config = JSON.parse(config)
      this.fl_ai = fl_ai;
      this.other = other

      if(this.config !== null){

        this.audio_record = this.config.audio_record;
        this.audio_record_variable = this.config.audio_record_variable;
        this.background_sound = this.config.background_sound;

        let attachments = new Map();

        if(this.config.background_sound_file && Object.keys(this.config.background_sound_file).length > 0) {

          attachments.set(this.config.background_sound_file.uuid, {
            'title'    : this.config.background_sound_file.title,
            'filename' : this.config.background_sound_file.filename,
            'status'   : this.config.background_sound_file.status,
            'path'     : this.config.background_sound_file.path,
            'ext'      : this.config.background_sound_file.ext,
            'uuid'     : this.config.background_sound_file.uuid
          })
          this.attachments_files = attachments;
        }
      }
    }
    if (this.action === 'create') {
      this.title = 'Создание бота'
    }
  },
  
  methods: {
    async saveItem(redirect = true){

      this.config = {
        'audio_record': this.audio_record,
        'audio_record_variable': this.audio_record_variable,
        'background_sound': this.background_sound,
        'background_sound_file': {}
      }

      if(this.attachments.size > 0){
        let attachments = [];
        this.attachments.forEach(el => {
          attachments.push(el);
        })
        this.config['background_sound_file'] = attachments[0];
      }

      let data_send = {
        ...this.other,
        'name': this.name,
        'google_table_url': this.google_table_url,
        'fl_ai': this.fl_ai ? 'true' : 'false',
        'user_phone': this.user_phone,
        'description': this.description,
        'version': 2,
        'config': JSON.stringify(this.config),
      };

      let result = '';

      console.log(data_send);

      if(this.action === 'create'){
        result = await this.$store.dispatch('bots/FETCH_BOTS_CREATE', data_send);
        // this.bot_uuid = result.uuid;
      } else {
        data_send.uuid = this.uuid;
        result = await this.$store.dispatch('bots/FETCH_BOTS_UPDATE', data_send);
      }

      if(result === false){
        alert('Возникла ошибка');
      } else {
        this.$emit('close')
      }

    },
    close() {
      this.$emit('close')
    }
  }  
}
</script>

<template>
  <div>
    <b-form class="form-horizontal" @submit.prevent="saveItem">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col">

              <b-form-group label="Имя бота" label-for="name">
                <b-form-input id="name" v-model="name" placeholder="Укажите имя бота"/>
              </b-form-group>

              <b-form-group label="Описание" label-for="description">
                <b-form-input id="description" v-model="description" placeholder="Укажите краткое описание бота" />
              </b-form-group>

              <b-form-checkbox v-model="audio_record" name="config_record" style="margin-top: 5px; margin-bottom: 5px" switch>
                Включить запись разговора
              </b-form-checkbox>

              <b-form-group
                  v-show="audio_record"
                  label="Название переменной для записи разговора"
                  label-for="audio_record_variable"
                  style="margin-top: 15px"
              >
                <b-form-input
                    id="audio_record_variable"
                    v-model="audio_record_variable"
                    placeholder="Укажите название переменной"
                />
              </b-form-group>

              <b-form-checkbox v-model="background_sound" name="config_background_sound" style="margin-top: 5px; margin-bottom: 5px" switch>
                Включить фоновый звук
              </b-form-checkbox>

              <UploadFile
                  v-show="background_sound && attaching_uuid"
                  v-bind:attaching_uuid="uuid"
                  v-bind:attaching_type="'bots'"
                  v-bind:attachments="attachments_files"
                  v-bind:btn_title="'Загрузить фоновый звук'"
                  v-bind:multiple="true"
                  v-bind:btn_icn="'uil-music'"
              />

              <b-form-group label="Передать на аккаунт пользователя" label-for="user_phone" style="margin-top: 15px">
                <b-form-input id="user_phone" v-model="user_phone" placeholder="Укажите номер телефона или e-mail пользователя"/>
              </b-form-group>

              <b-form-group label="Ссылка на Google таблицу" label-for="google_table_url" style="margin-top: 15px">
                <b-form-input id="google_table_url" v-model="google_table_url" placeholder="Укажите ссылку на google таблицу для выгрузки статистики"/>
              </b-form-group>

              <b-form-checkbox v-model="fl_ai" name="fl_ai" style="margin-top: 5px; margin-bottom: 5px" switch>
                Бот с ИИ
              </b-form-checkbox>
              
              <hr style="margin-bottom: 0 !important">

              <div class="btns-container" style="justify-content: flex-start; padding-left: 0px; padding-top: 25px">
                <button type="submit" class="btn btn-primary" style="margin-right: 10px">Сохранить</button>
                <button type="button" class="btn btn-light" @click="close">Отменить</button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </b-form>
  </div>
</template>

<style scoped>
.btns-container {
  padding: 0.75rem;
  display: flex;
  justify-content: flex-end;
}
</style>